/* action type */
import type { Action } from '../../store/state/state-manager';

export const OPEN_LOCAL_ACTION = 'OPEN_LOCAL_ACTION';

/* action creator */
export const openLocalAction = (actionPayload: Action['payload']) => {
  return {
    type: OPEN_LOCAL_ACTION,
    payload: actionPayload
  };
};
